import { render } from "./PlusIcon.vue?vue&type=template&id=1f5ba971&scoped=true"
const script = {}

import "./PlusIcon.vue?vue&type=style&index=0&id=1f5ba971&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5ba971"]])

export default __exports__